import React, { Component } from 'react'
import Icon from '../../../../ui/Icon'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames'
import DropdownCard from './DropdownCard'
import Tooltip from '../../../../ui/tooltips/Tooltip'

import { ReactComponent as IconInsert } from '../../../../../assets/svg/actions/icn-insert.svg'
import { ReactComponent as IconDelete } from '../../../../../assets/svg/actions/icn-delete-24px-grey.svg'
const iconCircle = require('../../../../../assets/svg/dashboard/video-edit/icn-circle.svg')
const iconSquare = require('../../../../../assets/svg/dashboard/video-edit/icn-square.svg')
const iconLine = require('../../../../../assets/svg/dashboard/video-edit/icn-line.svg')
const iconArrow = require('../../../../../assets/svg/dashboard/video-edit/icn-arrow.svg')
const iconComment = require('../../../../../assets/svg/dashboard/video-edit/icn-comment.svg')

export const CameraActions = () => {
    return (
        <div className="video-actions camera-actions">
            <div className="wrapper action-wrapper">
                <h6 className="title">Custom Angle</h6>
                <div className="buttons">

                    <Tooltip text="Right Angle">
                        <span className="action-btn camera-angle-btn right">
                            <Icon icon={faCircle} />
                        </span>
                    </Tooltip>

                    <Tooltip text="Left Angle">
                        <span className="action-btn camera-angle-btn left">
                            <Icon icon={faCircle} />
                        </span>
                    </Tooltip>

                    <Tooltip text="Top Angle">
                        <span className="action-btn camera-angle-btn top">
                            <Icon icon={faCircle} />
                        </span>
                    </Tooltip>

                    <Tooltip text="Bottom Angle">
                        <span className="action-btn camera-angle-btn bottom active">
                            <Icon icon={faCircle} />
                        </span>
                    </Tooltip>

                </div>
            </div>
        </div>
    )
}

export const AnnotateActions = ({
    disabled = true,
    circle = {
        show: true,
        disabled: false,
        active: false,
        onClick: console.log
    },
    square = {
        show: true,
        disabled: false,
        active: false,
        onClick: console.log
    },
    line = {
        show: true,
        disabled: false,
        active: false,
        onClick: console.log
    },
    arrow = {
        show: true,
        disabled: false,
        active: false,
        onClick: console.log
    },
    comment = {
        show: true,
        disabled: false,
        active: false,
        onClick: console.log
    },
    insertObj = {
        show: false,
        disabled: false,
        active: false,
        onClick: console.log
    },
    deleteObj = {
        show: false,
        disabled: false,
        onClick: console.log
    },
    colors = {
        show: false,
        disabled: false,
        fillColor: "#FFCA41",
        strokeColor: "#FFFFFF",
        onChangeFill: console.log,
        onChangeStroke: console.log
    },
    ...props
}) => {
    const clickHandler = (e, set) => {
        if (disabled || set.disabled || set.active) {
            e.preventDefault()
        } else {
            set.onClick(e)
        }
    }

    return (
        <div className={classNames("video-actions annotate-actions", { disabled })} {...props}>
            <div className="wrapper-group">
                <div className="wrapper action-wrapper">
                    <h6 className="title">Annotate</h6>
                    <div className="buttons">

                        <Tooltip text="Draw Circle">
                            <span
                                onClick={e => clickHandler(e, circle)}
                                className={classNames("action-btn annotate-btn", {
                                    active: circle.active,
                                    disabled: circle.disabled || disabled,
                                    hidden: circle.show
                                })}
                            >
                                <Icon svg={iconCircle} />
                            </span>
                        </Tooltip>

                        <Tooltip text="Draw Square">
                            <span
                                onClick={e => clickHandler(e, square)}
                                className={classNames("action-btn annotate-btn", {
                                    active: square.active,
                                    disabled: square.disabled || disabled || square.active,
                                    hidden: square.show
                                })}
                            >
                                <Icon svg={iconSquare} />
                            </span>
                        </Tooltip>

                        <Tooltip text="Draw Polygon">
                            <span
                                onClick={e => clickHandler(e, line)}
                                className={classNames("action-btn annotate-btn", {
                                    active: line.active,
                                    disabled: line.disabled || disabled || line.active,
                                    hidden: line.show
                                })}
                            >
                                <Icon svg={iconLine} />
                            </span>
                        </Tooltip>

                        <Tooltip text="Draw Arrow">
                            <span
                                onClick={e => clickHandler(e, arrow)}
                                className={classNames("action-btn annotate-btn", {
                                    active: arrow.active,
                                    disabled: arrow.disabled || disabled || arrow.active,
                                    hidden: arrow.show
                                })}
                            >
                                <Icon svg={iconArrow} />
                            </span>
                        </Tooltip>

                        <Tooltip text="Add Comment">
                            <span
                                onClick={e => clickHandler(e, comment)}
                                className={classNames("action-btn annotate-btn", {
                                    active: comment.active,
                                    disabled: comment.disabled || disabled || comment.active,
                                    hidden: comment.show
                                })}
                            >
                                <Icon svg={iconComment} />
                            </span>
                        </Tooltip>

                    </div>
                </div>
                <div className="wrapper action-wrapper">
                    <h6 className="title">Actions</h6>
                    <div className="buttons">

                        <DropdownCard
                            title={insertObj.title}
                            items={insertObj.items}
                            button={IconInsert}
                            onSelect={!insertObj.disabled || !disabled ? insertObj.onClick : e => e.preventDefault()}
                            disabled={insertObj.disabled || disabled}
                            className={classNames("action-btn insert-btn", {
                                active: colors.active,
                                disabled: insertObj.disabled || disabled,
                                hidden: insertObj.show
                            })}
                        />

                        <Tooltip text="Delete">
                            <span
                                onClick={!deleteObj.disabled || !disabled ? deleteObj.onClick : e => e.preventDefault()}
                                className={classNames("action-btn delete-btn", {
                                    disabled: deleteObj.disabled || disabled,
                                    hidden: deleteObj.show
                                })}
                            >
                                <IconDelete />
                            </span>
                        </Tooltip>

                    </div>
                </div>
                {colors.show ? (
                    <div className="wrapper action-wrapper">
                        <div className="d-flex">
                            <div className="fill-container">
                                <h6 className="title">Fill</h6>
                                <div className="buttons">
                                    <input
                                        name="fill"
                                        disabled={colors.disabled}
                                        type="color"
                                        className="form-color"
                                        value={colors.fillColor || "#FFCA41"}
                                        style={{ backgroundColor: colors.fillColor || "#FFCA41" }}
                                        onChange={colors.onChangeFill}
                                    />
                                </div>
                            </div>
                            <div className="stroke-container">
                                <h6 className="title">Stroke</h6>
                                <div className="buttons">
                                    <input
                                        name="stroke"
                                        disabled={colors.disabled}
                                        type="color"
                                        className="form-color"
                                        value={colors.strokeColor || "#FFFFFF"}
                                        style={{ backgroundColor: colors.strokeColor || "#FFFFFF" }}
                                        onChange={colors.onChangeStroke}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    )
}